/* RESPONSIBLE TEAM: team-inbox-experience */
import { attr } from '@ember-data/model';
import Fragment from 'ember-data-model-fragments/fragment';

export default Fragment.extend({
  statuspagePageId: attr('string'),
});
